import type {
  AdvancedMenuItem,
  MenuItemGroup,
} from '@blocksuite/affine/components/toolbar';

export function insertInviteMenuItem<T>(
  groups: MenuItemGroup<T>[],
  inviteItem: AdvancedMenuItem<T>
) {
  for (const group of groups) {
    const askAIIndex = group.items.findIndex(item => item.type === 'ask-ai');
    if (askAIIndex !== -1) {
      group.items.splice(askAIIndex + 1, 0, inviteItem);
      return;
    }
  }

  groups.unshift({
    type: 'invite-to-block',
    items: [inviteItem],
  });
}
